module.exports = __webpack_public_path__ + "img/grow_4.f7048580.png";